import {
  SET_DEFAULT_MAPPINGS,
  SET_REQUIRED_FIELDS,
  SET_RECORD_INDEX,
  SET_FILE_RECORD,
  SET_MERGE_STRATEGY,
  SET_IGNORED_RECORD_INDEX,
  SET_IGNORED_FILE_RECORD
} from '../actions/mapping';

const defaultState = {
  columnMappings: [],
  requiredFields: [],
  recordsCount: 0,
  error: null,
  recordIndex: 0,
  record: null,
  ignoredRecordIndex: 0,
  ignoredRecord: null,
  fileMapping: {},
  fieldOptions: []
};

export default function(state = defaultState, action) {
  switch (action.type) {
  case SET_DEFAULT_MAPPINGS:
    return {
      ...state,
      ...action
    };
  case SET_REQUIRED_FIELDS:
    return { ...state, fields: action.fields };
  case SET_RECORD_INDEX:
    return { ...state, recordIndex: action.index };
  case SET_FILE_RECORD:
    return { ...state, record: action.record };
  case SET_MERGE_STRATEGY: {
    const fileMapping = { ...state.fileMapping };
    fileMapping.mergeStrategy = action.mergeStrategy;
    return { ...state, fileMapping };
  }
  case SET_IGNORED_RECORD_INDEX:
    return { ...state, ignoredRecordIndex: action.ignoredRecordIndex };
  case SET_IGNORED_FILE_RECORD:
    return { ...state, ignoredRecord: action.ignoredRecord };
  default:
    return state;
  }
}
